"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mark;

var React = _interopRequireWildcard(require("react"));

var _markRegExp = _interopRequireDefault(require("./markRegExp"));

var _markTerm = _interopRequireDefault(require("./markTerm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

/**
 * Replaces matching patterns in a string with markers.
 *
 * @param {string | Array} content The content to parse and mark.
 *
 * @param {string | RegExp} rule The pattern to search and replace in the
 * content.
 *
 * @param {Function} tag A function that takes the match string and must return
 * a React component or a string. The value returned by that function will
 * replace the term in the output.
 *
 * @param {number} matchIndex The index of the match to use when marking with
 * a RegExp. If not provided, will use the last non-null match available.
 *
 * @returns {Array} An array of strings and React components, similar to the
 * original content but where each matching pattern has been replaced by a
 * marking component.
 */
function mark(content, rule, tag, matchIndex) {
  var _ref;

  if (!Array.isArray(content)) {
    content = [content];
  }

  if (!(rule instanceof RegExp || typeof rule === 'string')) {
    throw Error('Unsupported rule type for rule `' + rule + '`.');
  }

  var output = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var part = _step.value;

      if (typeof part === 'string') {
        var marked = void 0;

        if (rule instanceof RegExp) {
          marked = (0, _markRegExp["default"])(part, rule, tag, matchIndex);
        } else if (typeof rule === 'string') {
          marked = (0, _markTerm["default"])(part, rule, tag);
        }

        output.push(marked);
      } else {
        output.push(part);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return (_ref = []).concat.apply(_ref, output);
}